<div class="pinned">
  <div class="title">
    <nb-route-tabset [tabs]="tabs" [fullWidth]="true"></nb-route-tabset>
  </div>
  <div class="buttons">
    @if (type === TimeType.Calendar) {
      <button nbButton size="small" (click)="datepicker.date = null; dinput.click()"><nb-icon icon="calendar-outline"></nb-icon></button>
      <input nbInput #dinput style="visibility: hidden; width: 0; padding: 0 !important;" [nbDatepicker]="datepicker">
      <nb-datepicker #datepicker (dateChange)="pageWeek($event)"></nb-datepicker>
    }
    @if (canOthers) {
      <div>
        <label class="small-label">{{ 'registration.person' | translate }}</label>
        <bst-list-adder [placeholder]="'enterusers' | translate" [listTemplate]="userlisttemplate" [autolist]="true" [formControl]="curuser" [single]="true" size="small" status="basic" [filters]="{logo: true}" [target]="'member'"></bst-list-adder>
      </div>
    }
    <button nbButton size="small" ghost status="basic" class="export" (click)="openExport()">
      <nb-icon icon="download-outline"></nb-icon>
      <span>{{ 'tracking.export' | translate }}</span>
    </button>
  </div>
</div>
<section>
  <datalist id="internal-suggestions">
    @for (s of internalSuggestions; track s) { <option [value]="s"></option> }
  </datalist>
  @if (type === TimeType.Tracker) {
    <div>
      @if (!readonly) {
      <table class="tracker-block" [formGroup]="form">
        <tbody>
          <tr>
            <td>
              <div>
                <label class="small-label">{{ 'tracking.achieved' | translate }}</label>
                <textarea nbInput fullWidth rows="1" class="description-input" #note (input)="autogrow(note)" [placeholder]="(isInternal(form.get('userToPhase').value) ? 'tracking.descriptionrequired' : 'tracking.description') | translate" maxlength="250" formControlName="description"></textarea>
              </div>
            </td>
            <td class="project-cell">
              <div>
                <label class="small-label">{{ 'project' | translate }}</label>
                <ng-container [ngTemplateOutlet]="projectform" [ngTemplateOutletContext]="{form: form.get('userToPhase')}"></ng-container>
              </div>
            </td>
            <td class="date-cell">
              @if (!timeTrackingService.isTracking) {
                <div>
                  <label class="small-label">{{ 'tracking.date' | translate }}</label>
                  <input nbInput fullWidth [nbDatepicker]="datepicker" formControlName="tracked_on">
                  <nb-datepicker #datepicker format="D MMM" [max]="today.toDate()"></nb-datepicker>
                </div>
              }
            </td>
            <td class="time-cell">
              <div>
                <label class="small-label">
                  {{ 'tracking.from' | translate }}
                  {{ adate(true) }}
                </label>
                @if (!timeTrackingService.isTracking) {
                  <input nbInput fullWidth type="text" inputmode="numeric" maxlength="5" placeholder="00:00" formControlName="tracked_start"
                         (change)="normTime(form.get('tracked_start'), $any($event.target).value)">
                }
                @if (timeTrackingService.isTracking) {
                  <span class="timer">{{ form.get('tracked_start').value?.substring(0, 5) }}</span>
                }
              </div>
            </td>
            <td class="time-cell">
              <div>
                <label class="small-label">
                  {{ 'tracking.to' | translate }}
                  {{ adate(false) }}
                </label>
                @if (!timeTrackingService.isTracking) {
                  <input nbInput fullWidth type="text" inputmode="numeric" maxlength="5" placeholder="00:00" formControlName="tracked_end"
                         (change)="normTime(form.get('tracked_end'), $any($event.target).value)">
                }
                @if (timeTrackingService.isTracking) {
                  <span class="timer">{{ form.get('tracked_end').value?.substring(0, 5) }}</span>
                }
              </div>
            </td>
            <td class="duration-cell">
              <div>
                <label class="small-label">{{ 'tracking.duration' | translate }}</label>
                @if (!timeTrackingService.isTracking) {
                  <div>
                    <input nbInput fullWidth
                      oninput="if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
                      type="number" size="small" [min]="0" [max]="99" maxlength="2" [placeholder]="'tracking.hours' | translate" formControlName="tracked_hours">
                    <input nbInput fullWidth
                      oninput="if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
                      type="number" size="small" [min]="0" [max]="59" maxlength="2" [placeholder]="'tracking.minutes' | translate" formControlName="tracked_minutes">
                  </div>
                }
                @if ((timeTrackingService.timer | async); as s) {
                  <div>
                    <span class="timer">{{ s.tracked_durationString }}</span>
                  </div>
                }
              </div>
            </td>
            <td class="track-cell">
              <div class="track-buttons">
                @if (!timeTrackingService.isTracking && duration()) {
                  <button nbButton [bstErroring]="form" (bstErroringSuccess)="addTime()" status="primary">
                    <nb-icon icon="plus-circle"></nb-icon>
                    <span>{{ 'tracking.addtime' | translate }}</span>
                  </button>
                }
                @if (!this.timeTrackingService.isTracking && this.duration() && canOthers) {
                  <button nbButton class="others" [nbTooltip]="'tracking.others' | translate" nbTooltipStatus="success" [bstErroring]="form" (bstErroringSuccess)="openOthers()" status="primary">
                    <nb-icon icon="person-add"></nb-icon>
                  </button>
                }
                @if (!timeTrackingService.isTracking && !duration()) {
                  <button nbButton status="primary" (click)="toggleTracking()">
                    <nb-icon icon="play-circle"></nb-icon>
                    <span>{{ 'tracking.start' | translate }}</span>
                  </button>
                }
                @if (timeTrackingService.isTracking) {
                  <button nbButton status="danger" (click)="toggleTracking()">
                    <nb-icon icon="stop-circle"></nb-icon>
                    <span>{{ 'tracking.stop' | translate }}</span>
                  </button>
                }
              </div>
            </td>
          </tr>
        </tbody>
      </table>
      }
      <div class="tracker-list" infiniteScroll [infiniteScrollDistance]="3" [infiniteScrollThrottle]="100" [scrollWindow]="false" (scrolled)="this.scrolled()">
        @if (!trackings?.length && !isLoading) {
          <div class="noresults">
            {{ 'noresults' | translate }}
          </div>
        }
        @for (d of this.trackings; track d; let i = $index) {
          @if (weekHeader(d.date, i); as w) {
            <div class="week">
              <label>{{ w.start.format('MMM D') + ' - ' + w.end.format('MMM D') }}<span class="week-number">{{ ('week' | translate) + ' ' + w.week }}</span></label>
              <span class="total">{{ trackerTotalStr(w.info?.total) }}</span>
            </div>
          }
          <article>
            <div class="tracker-header" [class.active]="d.date.isSame(this.today, 'day')">
              <label>{{ (d.date.isSame(this.today) ? ('today' | translate)
              : (d.date.isSame(this.yesterday, 'day') ? ('yesterday' | translate) : d.date.format('dddd, D MMMM YYYY'))) }}</label>
              <span class="total">{{ trackerTotalStr(totalForDate(d.date)) }}</span>
            </div>
            @if (d.tracks?.length) {
              <table class="tracker-table">
                @for (trak of d.tracks; track trak.id) {
                  <tr [class.active]="open?.id === trak.id">
                    <td class="desc-cell">
                      <input nbInput fieldSize="small" class="tracker-desc-input" #desc [disabled]="readonly"
                             [value]="trak.description ?? ''"
                             [attr.list]="isInternal(trak.user_to_phase) ? 'internal-suggestions' : null"
                             [required]="isInternal(trak.user_to_phase)"
                             [placeholder]="(isInternal(trak.user_to_phase) ? 'tracking.descriptionrequired' : 'tracking.nodescription') | translate"
                             [nbTooltip]="trak.description ?? ''" [nbTooltipDisabled]="!Globals.clipped(desc)"
                             (blur)="commitTrackerDescription(trak, $any($event.target).value, $any($event.target))"
                             (keyup.enter)="$any($event.target).blur()">
                    </td>
                    <td class="project-cell">
                      <span class="proj-dot" [style.background-color]="trak.user_to_phase?.phase?.project?.color || 'transparent'"></span>
                      <span class="title-item">{{ trak.user_to_phase?.phase?.project?.name }}</span>
                      @if (trak.user_to_phase?.phase?.project?.for_client; as fc) {
                        <span class="client-item" [class.clickable-client]="fc.id" role="link" tabindex="0"
                              (click)="openClient(fc, $event)" (keydown.enter)="openClient(fc, $event)">{{ fc.name }}</span>
                      }
                      <span class="phase-item">{{ trak.user_to_phase?.phase?.name }}</span>
                    </td>
                    <td class="time-cell from">{{ trak.tracked_start?.substring(0, 5) }}</td>
                    <td class="time-cell to">{{ trak.tracked_end?.substring(0, 5) }}</td>
                    <td class="duration-cell">
                      <input nbInput fieldSize="small" type="text" class="tracker-cell-input" [disabled]="readonly"
                             [value]="cellDisplayPadded(trak.tracked_duration)"
                             (focus)="$any($event.target).select()"
                             (blur)="commitTrackerDuration(trak, $any($event.target).value)"
                             (keyup.enter)="$any($event.target).blur()">
                    </td>
                    <td class="edit-cell">
                      <bst-menu-dialog (openChanged)="$event ? this.open = trak : (this.open?.id === trak.id ? this.open = null : null);" [menu]="this.timeTrackingService.isTracking ? menu : trackMenu" [data]="trak"></bst-menu-dialog>
                    </td>
                  </tr>
                }
              </table>
            }
          </article>
        }
      </div>
    </div>
  }
      @if (type === TimeType.Calendar) {
        <div>
          @if (weeker; as w) {
            <div class="calendar-block">
              <bst-registration-approval-strip [hasHours]="hasHours" (changed)="onWeekChanged()"></bst-registration-approval-strip>
              @if (isMobile) {
                <!-- week strip: pick a day, see the whole week at a glance -->
                <div class="calendar-week-strip">
                  @for (d of w.days; track $index; let i = $index) {
                    <button type="button" class="day-chip"
                            [class.selected]="i === selectedDayIndex"
                            [class.today]="w.moments[i]?.isSame(today, 'day')"
                            [attr.aria-pressed]="i === selectedDayIndex"
                            [attr.aria-label]="w.days[i] + ' ' + w.dates[i]"
                            (click)="selectDay(i)">
                      <span class="chip-dow">{{ d.charAt(0) }}</span>
                      @if (dayChipLabel(w.totals[i]); as h) {
                        <span class="chip-total">{{ h }}</span>
                      } @else {
                        <span class="chip-dot"></span>
                      }
                    </button>
                  }
                </div>

                <!-- selected day, with prev/next day (crosses weeks at the edges) -->
                <div class="calendar-day-nav">
                  <button nbButton ghost status="basic" class="day-step" (click)="stepDay(-1)" aria-label="Previous day">
                    <nb-icon icon="arrow-ios-back-outline"></nb-icon>
                  </button>
                  <div class="day-label">
                    <span class="dow">{{ w.days[selectedDayIndex] }}</span>
                    <span class="date">{{ w.dates[selectedDayIndex] }}</span>
                    @if (w.totals[selectedDayIndex]?.hours || w.totals[selectedDayIndex]?.minutes) {
                      <span class="day-total">{{ trackerTotalStr(w.totals[selectedDayIndex]) }}</span>
                    }
                  </div>
                  <button nbButton ghost status="basic" class="day-step" (click)="stepDay(1)" aria-label="Next day">
                    <nb-icon icon="arrow-ios-forward-outline"></nb-icon>
                  </button>
                </div>

                <!-- one day's entries per project -->
                <div class="calendar-body mobile">
                  @for (project of weeks; track project.user_to_phase?.id ?? $index; let pi = $index) {
                    <div class="calendar-project mobile" [class.open]="project.open">
                      <button type="button" class="calendar-project-header mobile" (click)="project.open = !project.open"
                              [attr.aria-expanded]="project.open">
                        <nb-icon class="chevron" [icon]="project.open ? 'arrow-down' : 'arrow-right'"></nb-icon>
                        <span class="proj-meta">
                          <span class="proj-dot" [style.background-color]="project.user_to_phase?.phase?.project?.color || 'transparent'"></span><span class="title-item">{{ project.user_to_phase?.phase?.project?.name }}</span>
                          @if (project.user_to_phase?.phase?.project?.for_client; as fc) {
                            <span class="client-item" [class.clickable-client]="fc.id" role="link" tabindex="0"
                                  (click)="openClient(fc, $event)" (keydown.enter)="openClient(fc, $event)">{{ fc.name }}</span>
                          }
                        </span>
                        @if (project.wtotal[selectedDayIndex + 1]) {
                          <span class="proj-day-total">{{ trackerTotalStr(this.timeTrackingService.duration(project.wtotal[selectedDayIndex + 1])) }}</span>
                        }
                      </button>
                      @if (project.open) {
                        @for (trak of project.tracks; track $index; let ri = $index) {
                          <div class="calendar-project-body mobile">
                            <input nbInput fieldSize="small" class="desc-input"
                                   [disabled]="readonly"
                                   [value]="trak.description ?? ''"
                                   [attr.list]="isInternal(project.user_to_phase) ? 'internal-suggestions' : null"
                                   [required]="isInternal(project.user_to_phase)"
                                   [attr.aria-label]="'tracking.nodescription' | translate"
                                   [placeholder]="(isInternal(project.user_to_phase) ? 'tracking.descriptionrequired' : 'tracking.nodescription') | translate"
                                   (blur)="commitDescription(project, trak, $any($event.target).value, $any($event.target))"
                                   (keyup.enter)="$any($event.target).blur()">
                            <div class="cell-row">
                              @if (trak.phase) { <span class="phase-item">{{ trak.phase }}</span> }
                              <input nbInput fieldSize="small" type="text" inputmode="decimal" class="cell-input"
                                     [ngClass]="trak.tracks[selectedDayIndex + 1] > 0 ? cellState : null"
                                     [disabled]="readonly"
                                     [attr.aria-label]="(trak.phase || (trak.description ?? '')) + ' ' + w.days[selectedDayIndex] + ' ' + w.dates[selectedDayIndex]"
                                     [value]="cellDisplayPadded(trak.tracks[selectedDayIndex + 1])"
                                     (focus)="$any($event.target).select()"
                                     (blur)="commitCell(project, trak, selectedDayIndex + 1, $any($event.target).value, $any($event.target))"
                                     (keyup.enter)="$any($event.target).blur()">
                              <bst-menu-dialog [menu]="rowmenu" [data]="{project: project, trak: trak}"></bst-menu-dialog>
                            </div>
                          </div>
                        }
                        <div class="calendar-add-line">
                          <button nbButton ghost size="small" status="primary" [disabled]="readonly" (click)="addRow(project)">
                            <nb-icon icon="plus-outline"></nb-icon>
                            <span>{{ 'tracking.addline' | translate }}</span>
                          </button>
                        </div>
                      }
                    </div>
                  }
                  @if (!weeks?.length && !isLoading) {
                    <div class="noresults">{{ 'noresults' | translate }}</div>
                  }
                </div>

                <div class="calendar-bottom mobile">
                  <button nbButton fullWidth size="large" [disabled]="readonly" (click)="addTrack(w.moments[selectedDayIndex]?.toDate())" status="primary">
                    <nb-icon icon="plus-circle"></nb-icon>
                    <span>{{ 'tracking.addtime' | translate }}</span>
                  </button>
                  <button nbButton fullWidth ghost status="basic" [disabled]="readonly || isLoading" (click)="copyLastWeek()">
                    <nb-icon icon="copy-outline"></nb-icon>
                    <span>{{ 'tracking.copylastweek' | translate }}</span>
                  </button>
                </div>
              } @else {
                <div class="calendar-header">
                  <div class="calendar-dates">
                    <div class="side">
                      <label>{{ (w.inweek === -1 ? 'tracking.prevweek' : (w.inweek === 1 ? 'tracking.nextweek' : (w.inweek > 0 ? 'tracking.inweek' : (w.inweek < 0 ? 'tracking.outweek' : 'tracking.thisweek')))) | translate:{value: Math.abs(w.inweek)} }} <span class="week-number">{{ ('week' | translate) + ' ' + w.week }}</span></label>
                      <label>{{ w.range }}</label>
                    </div>
                    <button nbButton outline status="basic" (click)="pageWeek('prev')">
                      <nb-icon icon="arrow-left"></nb-icon>
                    </button>
                    @for (day of w.days; track day; let i = $index) {
                      <div class="dateadd" [class.today]="w.moments[i]?.isSame(today, 'day')" (click)="addTrack(w.moments[i]?.toDate(), null, null, null)">
                        <label>{{ day }}</label>
                        <span class="dates">{{ w.dates[i] }}</span>
                      </div>
                    }
                    <button nbButton outline status="basic" (click)="pageWeek('next')">
                      <nb-icon icon="arrow-right"></nb-icon>
                    </button>
                    <div></div>
                    <div class="row-menu"></div>
                  </div>
                  <div class="calendar-overview">
                    <div class="side">
                    </div>
                    <blockquote></blockquote>
                    @for (t of w.totals; track $index) {
                      <div>
                        <ng-container *ngTemplateOutlet="spanduration; context: {dur: t }"></ng-container>
                      </div>
                    }
                    <blockquote></blockquote>
                    <div>
                      <div class="time-duration single"><span>{{ trackerTotalStr(w.grand) }}</span></div>
                    </div>
                    <div class="row-menu"></div>
                  </div>
                </div>
                <div class="calendar-body">
                  @for (project of weeks; track project.user_to_phase?.id ?? $index; let pi = $index) {
                    <div class="calendar-project">
                      <div class="calendar-project-header">
                        <div class="side">
                          <button class="open-button" nbButton [status]="project.open ? 'primary' : 'basic'" size="small" shape="round" (click)="project.open = !project.open"><nb-icon [icon]="project.open ? 'arrow-down' : 'arrow-right'"></nb-icon></button>
              <ng-container *ngTemplateOutlet="projectlist; context: {result: {
              name: project.user_to_phase?.phase?.project?.name,
              color: project.user_to_phase?.phase?.project?.color,
              client: project.user_to_phase?.phase?.project?.for_client?.name,
              clientObj: project.user_to_phase?.phase?.project?.for_client,
              phase: null
            }}"></ng-container>
                        </div>
                        <blockquote></blockquote>
                        @for (t of weekdays; track t) {
                          <div>
                            @if (project.wtotal[t]) {
                              <span>
                                <ng-container *ngTemplateOutlet="spanduration; context: {dur: this.timeTrackingService.duration(project.wtotal[t]) }"></ng-container>
                              </span>
                            }
                          </div>
                        }
                        <blockquote></blockquote>
                        <div>
                          @if (project.total) {
                            <div class="time-duration single"><span>{{ trackerTotalStr(this.timeTrackingService.duration(project.total)) }}</span></div>
                          }
                        </div>
                        <div class="row-menu"></div>
                      </div>
                      @if (project.open) {
                        @for (trak of project.tracks; track $index; let ri = $index) {
                          <div class="calendar-project-body">
                            <div class="side" [nbTooltip]="trak.description ?? ''" [nbTooltipDisabled]="!Globals.clipped(desc)">
                              <input nbInput fieldSize="small" class="desc-input" #desc
                                     [disabled]="readonly"
                                     [value]="trak.description ?? ''"
                                     [attr.list]="isInternal(project.user_to_phase) ? 'internal-suggestions' : null"
                                     [required]="isInternal(project.user_to_phase)"
                                     [placeholder]="(isInternal(project.user_to_phase) ? 'tracking.descriptionrequired' : 'tracking.nodescription') | translate"
                                     (blur)="commitDescription(project, trak, $any($event.target).value, $any($event.target))"
                                     (keyup.enter)="$any($event.target).blur()">
                              <span class="phase-item">{{ trak.phase }}</span>
                            </div>
                            <blockquote></blockquote>
                            @for (t of weekdays; track t; let i = $index) {
                              <div class="weekday" [ngClass]="trak.tracks[t] > 0 ? cellState : null">
                                <input nbInput fieldSize="small" type="text" class="cell-input"
                                       [disabled]="readonly"
                                       [attr.data-cell]="pi + '-' + ri + '-' + t"
                                       [value]="cellDisplayPadded(trak.tracks[t])"
                                       (focus)="$any($event.target).select()"
                                       (blur)="commitCell(project, trak, t, $any($event.target).value, $any($event.target))"
                                       (keydown)="cellKey($event, pi, ri, t)">
                              </div>
                            }
                            <blockquote></blockquote>
                            <div>
                              <div class="time-duration single"><span>{{ trackerTotalStr(this.timeTrackingService.duration(trak.total)) }}</span></div>
                            </div>
                            <div class="row-menu">
                              <bst-menu-dialog [menu]="rowmenu" [data]="{project: project, trak: trak}"></bst-menu-dialog>
                            </div>
                          </div>
                        }
                        <div class="calendar-add-line">
                          <button nbButton ghost size="tiny" status="basic" [disabled]="readonly" (click)="addRow(project)">
                            <nb-icon icon="plus-outline"></nb-icon>
                            <span>{{ 'tracking.addline' | translate }}</span>
                          </button>
                        </div>
                      }
                    </div>
                  }
                  @if (!weeks?.length && !isLoading) {
                    <div class="noresults">
                      {{ 'noresults' | translate }}
                    </div>
                  }
                </div>
                <div class="calendar-bottom">
                  <button nbButton ghost status="basic" [disabled]="readonly || isLoading" (click)="copyLastWeek()"
                          [nbTooltip]="'tracking.copylastweekhint' | translate">
                    <nb-icon icon="copy-outline"></nb-icon>
                    <span>{{ 'tracking.copylastweek' | translate }}</span>
                  </button>
                  <button nbButton [disabled]="readonly" (click)="addTrack(this.date.toDate())" status="primary">
                    <nb-icon icon="plus-circle"></nb-icon>
                    <span>{{ 'tracking.addtime' | translate }}</span>
                  </button>
                </div>
              }
            </div>
          }
        </div>
      }
    </section>

    <ng-template #spanduration let-dur="dur">
      @if (dur && (dur.hours || dur.minutes)) {
        <div class="time-duration">
          <span>{{ (dur.hours || 0) + ('tracking.hours' | translate) }}</span>
          <span>{{ pad2(dur.minutes) + ('tracking.minutes' | translate) }}</span>
        </div>
      }
    </ng-template>

    <ng-template #projectlist let-result="result" let-index="index">
      <span class="proj-dot" [style.background-color]="result.color || 'transparent'"></span><span class="title-item">{{ result.name }}</span>
      @if (result.clientObj?.id) {
        <span class="client-item clickable-client" role="link" tabindex="0"
              (click)="openClient(result.clientObj, $event)"
              (keydown.enter)="openClient(result.clientObj, $event)">{{ result.client }}</span>
      } @else {
        <span class="client-item">{{ result.client }}</span>
      }
      <br>
        @if (result.phase) {
          <span class="phase-item">{{ result.phase }}</span>
        }
      </ng-template>

      <ng-template #projectform let-f="form">
        <bst-list-adder fullWidth [single]="true" [autolist]="true" [fullWidthResults]="true" [noresults]="'tracking.noresults'" [listTemplate]="projectlist" [target]="'myproject'" [filters]="{user: curuser.value?.id}" [formControl]="f"></bst-list-adder>
      </ng-template>

      <ng-template #durationform let-f="fields">
        <div class="edit-duration" data-name="tracked_duration">
          <input nbInput fullWidth
            oninput="if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
            type="number" size="small" [min]="0" [max]="99" maxlength="2" [placeholder]="'tracking.hours' | translate" [formControl]="f.get('tracked_hours')">
            <input nbInput fullWidth
              oninput="if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
              type="number" size="small" [min]="0" [max]="59" maxlength="2" [placeholder]="'tracking.minutes' | translate" [formControl]="f.get('tracked_minutes')">
            </div>
          </ng-template>

          <ng-template #userResultBodyTemplate let-data="data" let-params="params" let-select="select" let-isSelected="isSelected" let-i="i">
            <tr class="search-body-row">
              <td>
                <nb-user color="#ccfce3" size="medium" [picture]="logo(data)" [name]="data.name" [title]="data.username" (click)="select.next(data)"></nb-user>
              </td>
              <td>
                {{ data.subtitle }}
              </td>
              <td>
                <button nbButton status="primary" size="small" (click)="select.next(data)">
                  <span>{{ 'tracking.select' | translate }}</span>
                  <nb-icon icon="arrow-circle-right-outline"></nb-icon>
                </button>
              </td>
            </tr>
          </ng-template>

          <ng-template #userSelectionBodyTemplate let-data="data" let-params="params" let-select="select">
            <tr class="search-body-row">
              <td>
                <nb-user color="#ccfce3" size="medium" [picture]="logo(data)" [name]="data.name" [title]="data.username" (click)="select.next(data)"></nb-user>
              </td>
              <td>
                <button nbButton size="small" status="danger" (click)="select.next(data)">
                  <nb-icon icon="minus-circle-outline"></nb-icon>
                </button>
              </td>
            </tr>
          </ng-template>
          <ng-template #userSelectionHeaderTemplate>
            <tr class="search-header-row">
              <th>
                {{ 'name' | translate }}
              </th>
              <th></th>
            </tr>
          </ng-template>

          <ng-template #userResultHeaderTemplate>
            <tr class="search-header-row">
              <th>
                {{ 'name' | translate }}
              </th>
              <th>
                {{ 'seniority' | translate }}
              </th>
              <th></th>
            </tr>
          </ng-template>

          <ng-template #userlisttemplate let-result="result" let-index="index">
            <nb-user color="#eee" [name]="result.name" [picture]="logo(result)" size="small"></nb-user>
          </ng-template>
